import { useRegisterCommandBarCommands } from '@sketch/modules-common'
import { useGetActiveSidebarTab } from '../../shares/components/ShareSidebarTabContext'
import { createAddAnnotationCommands } from './createAddAnnotationCommands'

interface AddAnnotationCommandBarRegistrationProps {
  isViewingLatestVersion: boolean
  setPlaceDraftAnnotation: (value: boolean) => void
}

export const AddAnnotationCommandBarRegistration = ({
  isViewingLatestVersion,
  setPlaceDraftAnnotation,
}: AddAnnotationCommandBarRegistrationProps) => {
  const activeSidebarTab = useGetActiveSidebarTab()
  const isInspectorActive = activeSidebarTab === 'Inspect'

  useRegisterCommandBarCommands(
    'add-annotation',
    () =>
      createAddAnnotationCommands({
        isInspectorActive,
        isViewingLatestVersion,
        setPlaceDraftAnnotation,
      }),
    [isViewingLatestVersion, isInspectorActive]
  )

  return null
}
